import axios from "axios";
import { TTP_API_URL } from "../config";


export const getErpData = (token, id) => {
    const requestUrl = `${TTP_API_URL}/team/erp-data`;
  
    let params = {
      organization_id: id,
      access_token: token,
      organizationId: id,
    };
  
    return axios.get(requestUrl, { params });
  };
  